import React from 'react';
import {getPresentationThemeFontSizeOptions} from '../../../../../utils/presentationTheme';
import {FontSize, IPresentationTheme} from '../../../../../incase-domain/presentationTheme';
import Label from '../../../../../incase-domain/components/label/Label';
import Select from '../../../../components/common/Select';

interface SelectQuestionElementFontSizeProps {
    title: string;
    placeholder: string;
    elementFontSize: FontSize | undefined;
    setElementFontSize: (fontSize: FontSize | undefined) => void;
    presentationTheme: IPresentationTheme;
}

export default function SelectQuestionElementFontSize(props: SelectQuestionElementFontSizeProps): JSX.Element {
    const {title, placeholder, elementFontSize, setElementFontSize, presentationTheme} = props;

    const options = getPresentationThemeFontSizeOptions(presentationTheme.fontSizes);

    return (
        <div className="u-flex u-h-between u-v-center l-grid u-pb-2 l-grid--noGaps ">
            <div className="l-col:4">
                <Label size="lg">{title}</Label>
            </div>
            <div className="l-col:4">
                <Select
                    value={options.find((option) => option.label.split(':')[0] === elementFontSize?.size)}
                    onChange={(newValue) => {
                        newValue &&
                            setElementFontSize({
                                size: newValue.label.split(':')[0],
                                value: parseFloat(newValue.value as string),
                            } as FontSize);
                    }}
                    options={options}
                    placeholder={placeholder}
                />
            </div>
        </div>
    );
}
